import React, { useEffect, useState } from 'react'

import Select from 'react-select'

import { PackageOption } from './ESignatureMapping'
import { ApplicationProfile } from '@/types/unlock'

type ESignatureSelect = {
  dispatch: React.Dispatch<any>
  applicantProfile: ApplicationProfile
  applicantNotSelected: boolean
  defaultPackageValue?: string | null
  availableOptions?: PackageOption[]
}

export function ESignatureSelect({
  dispatch,
  applicantProfile,
  applicantNotSelected,
  defaultPackageValue,
  availableOptions,
}: ESignatureSelect) {
  const [selectedValue, setSelectedValue] = useState<PackageOption | null>(null)

  useEffect(() => {
    if (!applicantNotSelected) {
      const defaultOption = availableOptions.find((opt) => opt.value === defaultPackageValue)
      if (defaultOption && defaultOption.value !== selectedValue?.value) {
        setSelectedValue(defaultOption)
        dispatch({
          type: 'setESignatures',
          payload: {
            applicationProfileId: applicantProfile.id,
            doc: defaultOption.value,
            message: `Please eSign the following document: ${defaultOption.label}`,
          },
        })
      }
    }
  }, [applicantNotSelected, defaultPackageValue, availableOptions, applicantProfile.id, dispatch])

  useEffect(() => {
    if (applicantNotSelected) {
      if (selectedValue) {
        setSelectedValue(null)
        dispatch({
          type: 'setESignatures',
          payload: { action: 'remove', applicationProfileId: applicantProfile.id },
        })
      }
    }
  }, [
    applicantNotSelected,
    selectedValue,
    defaultPackageValue,
    availableOptions,
    applicantProfile.id,
    dispatch,
  ])

  return (
    <div key={applicantProfile?.id}>
      <Select
        options={availableOptions}
        placeholder='Select eSignature document'
        isDisabled={applicantNotSelected}
        value={selectedValue}
        styles={{
          control: (base, state) => ({
            ...base,
            borderColor:
              !applicantNotSelected && !selectedValue && !defaultPackageValue
                ? 'red'
                : base.borderColor,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        onChange={(selectedOption: PackageOption | null) => {
          setSelectedValue(selectedOption)
          if (selectedOption) {
            dispatch({
              type: 'setESignatures',
              payload: {
                applicationProfileId: applicantProfile.id,
                doc: selectedOption.value,
                message: `Please eSign the following document: ${selectedOption.label}`,
              },
            })
          } else {
            dispatch({
              type: 'setESignatures',
              payload: { action: 'remove', applicationProfileId: applicantProfile.id },
            })
          }
        }}
      />
    </div>
  )
}
